export default "__VITE_ASSET__ufxzMSFW__"